import { FunnelChart } from '@mantine/charts';

import { getSeriesColor } from '#core/lib/formatters/colors.ts';
import { makeFieldFormatter } from '#core/lib/formatters/number-decimals.ts';

import classes from '../Chart.module.css';
import type { ChartRendererProps } from '../types.ts';

/**
 * Converts generic data to funnel format {name, value, color}.
 */
function toFunnelData(
  data: Record<string, unknown>[],
  xAxis: string,
  yAxis: string,
): { name: string; value: number; color: string }[] {
  return data.map((row, i) => ({
    name: String(row[xAxis] ?? `Item ${i + 1}`),
    value: typeof row[yAxis] === 'number' ? row[yAxis] : 0,
    color: getSeriesColor(i),
  }));
}

/**
 * Renders funnel chart.
 */
export function FunnelChartRenderer({ config, width, height }: ChartRendererProps) {
  const funnelData = toFunnelData(config.data, config.xAxis, config.yAxis);
  const size = Math.min(width, height) - 40;

  return (
    <FunnelChart
      className={classes.chart}
      data={funnelData}
      size={size}
      valueFormatter={makeFieldFormatter(config.data, config.yAxis)}
      withLabels
      withTooltip
    />
  );
}
